module.exports = __webpack_public_path__ + "static/img/14000666.f92b3a20.png";